<input
  [formControl]="control"
  [fluid]="true"
  pInputText
  placeholder="Wprowadź wartość"
  step="0.01"
  type="number" />
